import React, { Component } from 'react';
import { withRouter } from 'react-router';

import DotLine from '../../DotLine';
import CourseDetail from './CourseDetail/CourseDetail';
import PriceDetail from './PriceDetail/PriceDetail';
import DetailButton from './DetailButton/DetailButton';
import tvIcon from '../../../assets/image/icon_tv.svg';
import internetIcon from '../../../assets/image/icon_internet.svg';
import phoneIcon from '../../../assets/image/icon_phone.svg';

class PlanCard extends Component {

  render() {
    const { plan } =  this.props;

    let className = 'PlanCard';
    if (plan.dummy) {
      className += ' Hidden';
    }
    if (plan.best) {
      className += ' Best';
    }

    const {
      tvCourse,
      tvCourseWeight,
      tvPrice,
      tvPriceWithTax,
      fourK,
      internetCourse,
      internetCourseWeight,
      internetPrice,
      internetPriceWithTax,
      phoneCourse,
      phoneCourseWeight,
      phonePrice,
      phonePriceWithTax,
      discountValue,
      discountValueWithTax,
      totalPrice,
      totalPriceWithTax,
      discountPrice,
      discountPriceWithTax,
      smartValue,
      homeDicount,
    } =  plan;

    console.log(totalPriceWithTax)

    const tv = tvCourseWeight ? (
      <React.Fragment>
        <div className="PlanCardRow" >
          <img src={tvIcon} className="PlanCardIcon" alt="tvIcon" />
          <CourseDetail
            name={tvCourse}
            price={tvPrice}
            priceWithTax={tvPriceWithTax}
          />
        </div>
        <DotLine PlanCard />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <div className="PlanCardRow" ></div>
        <DotLine PlanCard />
      </React.Fragment> 
    );

    const internet = internetCourseWeight ? (
      <React.Fragment>
        <div className="PlanCardRow" >
          <img src={internetIcon} className="PlanCardIcon" alt="internetIcon" />
          <CourseDetail
            name={internetCourse}
            price={internetPrice}
            priceWithTax={internetPriceWithTax}
          />
        </div>
        <DotLine PlanCard />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <div className="PlanCardRow" ></div>
        <DotLine PlanCard />
      </React.Fragment> 
    );

    const phone = phoneCourseWeight ? (
      <React.Fragment>
        <div className="PlanCardRow" >
          <img src={phoneIcon} className="PlanCardIcon" alt="phoneIcon" />
          <CourseDetail
            name={`でんわ (${phoneCourse})`}
            price={phonePrice}
            priceWithTax={phonePriceWithTax}
            smartValue={smartValue}
          />
        </div>
        <DotLine PlanCard />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <div className="PlanCardRow RowPhone" ></div>
        <DotLine PlanCard />
      </React.Fragment> 
    );

    return (
      <div
        className={className}
      >
        {tv}
        {internet}
        {phone}
        <PriceDetail
          naturalPrice={totalPrice}
          naturalPriceWithTax={totalPriceWithTax}
          discountValue={discountValue}
          discountValueWithTax={discountValueWithTax}
          discountPrice={discountPrice}
          discountPriceWithTax={discountPriceWithTax}
          smartValue={smartValue}
          fourK={fourK}
          homeDicount={homeDicount}
        />
      <DetailButton onClick={this.props.onClick} />
      </div>
    );
  };
};

export default withRouter(PlanCard);
